<script>
  import { debounce, ignore } from '../../Common/tools';
  import Checkbox from '../../Common/Checkbox.svelte';
  import { External, M } from '../../external';
  import Categories from '../../LMS/popups/Categories.svelte';
  import Slider from '../../Common/Slider.svelte';
  import { changeButtonStyling } from './ButtonStyling.svelte';
  import { onMount } from 'svelte';

  export let widget,
    onChange = ignore,
    onRender = ignore;

  let options = widget.data.options;

  let widgetUi = widget.$widget;

  let pickCategory = () => {
    External.Tools.showWindow({
      isModal: false,
      withDarkBackground: true,
      width: 420,
      buttons: [],
      noNav: true,
      noTitle: true,
      //forceAtRight: window.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(new Categories({
            target: popup.getContentArea(),
            props: {
              selectedIds: options.categories || [],
              onChange: (selectedIds) => {
                options.categories = selectedIds;
                triggerRenderChange();
              }
            }
          }));
        }
      }
    });
  };

  let showButtonStyling = async () => {
    let result = await changeButtonStyling(options.button || {});
    if (result) {
      options.buttons = result;
    }
  }

  let triggerRenderChange = debounce(() => {
    onChange();
    onRender();
  }, 250);

  onMount(() => {
    options.itemsPerRow = options.itemsPerRow || 3;
  });
</script>

<div class="popup-widget-wrapper form-admin-style-2">
  <div class="col20 f-left">
    <Checkbox bind:data={options.ownedFirst} onChange={triggerRenderChange} label="{M.HIGHLIGHT_USER_CIRCLE}"
              description="{M.HIGHLIGHT_USER_CIRCLE_DESC}" />
  </div>

  <div class="col20 f-left">
    <Checkbox bind:data={options.filterCategory} onChange={triggerRenderChange} label="{M.SHOW_FILTER_BY_CATEGORY}"
              description="{M.SHOW_FILTER_BY_CATEGORY_CIRCLE_DESC}" />
  </div>

  {#if options.filterCategory}
    <div class="col20 f-left gray-section product-select-wrapper mb-10">
      <div class="col20 f-left ab-step center-vertically">
        <h4 class="roboto">{M.CIRCLE_CATEGORIES}</h4>
        <a on:click={pickCategory} class="text-link blue-text">{M.CHANGE}</a>
      </div>
    </div>
  {/if}

  <div class="input-wrapper">
    <Slider bind:value={options.itemsPerRow} min={2} max={5} suffix=""
            label="{M.CIRCLES_PER_ROW}" onChange={triggerRenderChange} />
  </div>
  <div class="col20 f-left">
    <Checkbox bind:data={options.darkTheme} onChange={triggerRenderChange} label="{M.USE_DARK_THEME}"
              description="{M.USE_DARK_THEME_CIRCLES}" />
  </div>
  <div class="col20 f-left">
    <Checkbox bind:data={options.withButton} onChange={triggerRenderChange} label="{M.SHOW_BUY_BUTTON_CIRCLES}"
              description="{M.SHOW_BUY_BUTTON_CIRCLES_DESC}" />
  </div>

  <div class="col20 f-left mt-15">
    <h5>{M.STYLE}</h5>
    <select bind:value={options.style} on:change={triggerRenderChange}>
      <option value="">{M.STYLE_1}</option>
      <option value="style-2">{M.STYLE_2}</option>
    </select>
  </div>
<!--
  {#if options.withButton}
    <div class="col20 mb-5 f-left gray-section product-select-wrapper">
      <div class="col20 f-left ab-step center-vertically">
        <h4 class="roboto">Button Styling</h4>
        <a on:click={showButtonStyling} class="text-link blue-text">Change</a>
      </div>
    </div>
  {/if}
  -->
</div>
